import React, { useState, useEffect, useContext } from 'react';
import { withRouterProps } from '../.././common/withRouterProps';
import { AppContext } from '../../../RoutesWithAuth';
import { makeStyles } from "@mui/styles";
import Typography from '@mui/material/Typography';
import { Tooltip, Button, Grid, Tab, Tabs, IconButton } from '@mui/material';
import CreatePrivacyTask from '../newUI/centra/CreatePrivacyTask';
import PrivacyTasks from '../newUI/centra/PrivacyTasks';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import SettingsIcon from '@mui/icons-material/Settings';
import AddIcon from '@mui/icons-material/Add';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';


const useStyles = makeStyles(() => ({
    homePageWrapper: {
        fontSize: '0.8rem',
        height: "100%",
    },
    centraTabWrapper: {
        background: '#fff',
        height: "100%"
    },
    verticalTabGridItem: {
        maxWidth: '200px',
        background: '#0E2841',
        borderRight: '1px solid #e2e8f0',
        //borderRadius: '10px 0 0 10px',
        padding: '10px 0',
        minHeight: '100vh',
    },
    centraHeaderSidebarDivider: {
        borderTop: '1px solid #404040',
        paddingBottom: '10px'
    },
    brandTitle: {
        color: '#FFC000',
        paddingLeft: '35px',
        fontSize: '1.5rem',
        lineHeight: '1.7rem',
        //paddingBottom: '10px'
    },
    brandTagline: {
        display: 'inline-block',
        color: '#FFFFFF',
        fontSize: '0.9rem'
    },
    sidebarDivider: {
        borderTop: '1px solid #eee3e3',
        width: '100vw',
        marginLeft: '-15px'
    },
    toolbar: {
        paddingLeft: '15px',
        paddingTop: '250px',
        '& .MuiButton-root': {
            textTransform: 'none'
        }
    },
    verticalTabWrapper: {
        '& .MuiTabs-indicator': {
            display: 'none'
        },
        '& .MuiTab-root': {
            minHeight: '44px',
            margin: '2px 10px',
            width: 'calc(100% - 35px)',
            maxWidth: 'none',
            borderRadius: '4px',
            justifyContent: 'flex-start',
            textTransform: 'none'
        },
        '& .MuiTab-root.Mui-selected': {
            backgroundColor: '#3924FC',
            color: '#FFFFFF'
        }
    },
    navigationTab: {
        color: '#FFFFFF',
        opacity: 1
    },
    privacyTasksIcon: {
        width: '20px',
        height: '20px'
    },
    createPrivacyTaskButton: {
        backgroundColor: '#3924FC',
        color: '#FFFFFF',
        height: '2.5rem'
    },
    verticalTabGridContent: {
        maxWidth: 'calc( 100% - 180px)',
        overflow: 'hidden',
        background: '#fff',
        padding: '10px',
        '& .scopeHeader': {
            display: 'none',
        },
        '& > div > .header, & > div > div > .header': {
            display: 'none',
        },
    },
    rightPanelHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        minHeight: '58.5px',
        paddingLeft: '18px',
        fontSize: '1.5rem',
        lineHeight: '1.6rem',
        '& h6': {
            fontSize: '1.5rem',
            lineHeight: '1.6rem'
        }
    },
    userControls: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 'auto',
        paddingRight: '20px'
    },
    userInitials: {
        width: '30px',
        height: '30px',
        marginLeft: '25px',
        borderRadius: '50%',
        backgroundColor: '#3924FC',
        color: '#FFFFFF',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '0.75rem',
        fontWeight: 700
    },
}));

// TabHistoryPaths Variable Holds all the tab paths available in the Admin Screen
const TabHistoryPaths = [
    "dashboard",
    "privacyTasks",
    "adminSettings",
    "createPrivacyTask"
];


function CentraMainGrid(props) {
    const classes = useStyles();
    const context = useContext(AppContext);
    const [verticalTab, setVerticalTab] = useState(false);
    const { routerProps } = props
    const { history, match } = routerProps;

    useEffect(() => {
        if (match?.params?.page) {
            const tabIndex = TabHistoryPaths.indexOf(match.params.page);
            setVerticalTab(tabIndex >= 0 ? tabIndex : false);
        } else {
            setVerticalTab(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[match])

    const handleClick = () => {
        setVerticalTab(3);
        const path = TabHistoryPaths[3];
        history.push(`/centra/${path}`)
    }

    const activeTabName = verticalTab === false ? null : TabHistoryPaths[verticalTab];
    const userName = context.userName.get || '';
    const userInitials = userName
        .trim()
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map(name => name.charAt(0).toUpperCase())
        .join('');

    const renderRightPanelHeader = (title) => (
        <div className={classes.rightPanelHeader}>
            <Typography variant="h6">{title}</Typography>
            <div className={classes.userControls}>
                <Tooltip title="Notifications">
                    <IconButton size="small" aria-label="Notifications">
                        <NotificationsNoneIcon style= {{color: 'black'}} fontSize="medium" />
                    </IconButton>
                </Tooltip>
                <Tooltip title={userName || 'User'}>
                    <div className={classes.userInitials}>{userInitials || 'U'}</div>
                </Tooltip>
                <IconButton size="small" aria-label="User menu">
                    <ArrowDropDownIcon />
                </IconButton>
            </div>
        </div>
    );

    return (
        <div className={`${classes.homePageWrapper}`}>
            <Grid container className={classes.centraTabWrapper}>
                <Grid item xs className={classes.verticalTabGridItem}>
                    <div className={classes.verticalTabWrapper}>
                        <Typography className={classes.brandTitle} variant="h6">
                            CENTRA
                            <span className={classes.brandTagline}>Privacy Simplified</span>
                        </Typography>
                        <div className={classes.centraHeaderSidebarDivider} />
                        <Tabs
                            orientation="vertical"
                            variant="scrollable"
                            value={verticalTab}
                            onChange={(_event, newValue) => {
                                setVerticalTab(newValue);
                                const path = TabHistoryPaths[newValue];
                                history.push(`/centra/${path}`)
                            }}
                            aria-label="Vertical tabs"
                        >
                            <Tab className={classes.navigationTab} icon={<DashboardOutlinedIcon />} iconPosition="start" label="Dashboard" />
                            <Tab
                                className={classes.navigationTab}
                                icon={<img className={classes.privacyTasksIcon} src={`${process.env.PUBLIC_URL}/left_privacy_tasks_centra.svg`} alt="Privacy Tasks" />}
                                iconPosition="start"
                                label="Privacy Tasks"
                            />
                            <Tab className={classes.navigationTab} icon={<SettingsIcon />} iconPosition="start" label="Admin Settings" />
                        </Tabs>
                        <div className={classes.toolbar}>
                            <Tooltip title="Create Privacy Task">
                                <Button className={classes.createPrivacyTaskButton} startIcon={<AddIcon />} variant="outlined" size="small" onClick={handleClick}>
                                    Create Privacy Task
                                </Button>
                            </Tooltip>
                        </div>
                    </div>

                </Grid>
                <Grid item xs className={classes.verticalTabGridContent}>
                    {activeTabName === "privacyTasks" && (
                        <div>
                            {renderRightPanelHeader('Privacy Tasks Summary')}
                            <div className={classes.sidebarDivider} />
                            <PrivacyTasks/>
                        </div>
                    )}
                    {activeTabName === "createPrivacyTask" && (
                        <div>
                            {renderRightPanelHeader('Create Privacy Task')}
                            <div className={classes.sidebarDivider} />
                            <CreatePrivacyTask/>
                        </div>
                    )}
                </Grid>
            </Grid>
        </div>
    );
}

export default withRouterProps(CentraMainGrid);
